module.exports = require("@material/drawer/dist/mdc.drawer");


//////////////////
// WEBPACK FOOTER
// external {"root":"@material/drawer/dist/mdc.drawer","commonjs2":"@material/drawer/dist/mdc.drawer","commonjs":"@material/drawer/dist/mdc.drawer","amd":"@material/drawer/dist/mdc.drawer","umd":"@material/drawer/dist/mdc.drawer"}
// module id = 17
// module chunks = 0